import reservations from './index.js';

const SET_LOADING = (state, loading) => {
  state.loading = loading
};

const SET_RESERVATIONS = (state, reservations) => {
  state.reservations = reservations
};

const SET_SELECTED_RESERVATION = (state, index) => {
  state.selectedReservation = state.reservations[index];
  state.selectedIndex=index;
};

const SET_SELECTED_RESERVATION_BY_ID = (state, reservation) => {
  state.selectedReservation = reservation;
}

const SET_CUSTOMER_RESERVATIONS = (state,customerReservations) =>{
  state.customerReservations=customerReservations;
}

const DELETE_SELECTED_RESERVATION = (state) =>{

  state.reservations.splice(state.selectedIndex,1);
}
const INVALIDATE_LIST = (state) =>{
  state.outDated = true;
}
const SET_COUNT = (state, count)=>{
  state.count = count;
}
const SET_PAGES = (state, pages)=>{
  state.pages = pages;
}
const SET_PAGE = (state, page)=>{
  state.page = page;
}
const SET_SEARCH_TERMS = (state, searchTerms)=>{
  state.searchTerms=searchTerms;
}
const SET_ORDERNAME_AND_DIRECTION = (state, {orderName, direction})=>{
  state.orderBy.orderName = orderName;
  state.orderBy.direction = direction;
}
const SET_SORT_ICON = (state, icon)=>{
  state.sort_icon =icon;
}

const UPDATE_SELECTED_RESERVATION = (state, reservation) =>{
  Object.assign(state.reservations[state.selectedIndex], reservation);
}

const SET_ACTIVE_TAB = (state, activeTab)=>{
  state.activeTab = activeTab;
}

const SET_FILTER_ACTIVE = (state, active)=>{
  state.filters.active = active;
}

const SET_FILTER_INTENT = (state, intent)=>{
  state.filters.intent = intent;
}

const SET_FILTER_COMPLETED = (state, completed)=>{
  state.filters.completed = completed;
}


const SET_FILTER_INACTIVE = (state, inactive)=>{
  state.filters.inactive = inactive;
}

const SET_FILTER_RED_FLAG = (state, redFlag)=>{
  state.filters.redFlag = redFlag;
}
const SET_FILTER_YELLOW_FLAG = (state, yellowFlag)=>{
  state.filters.yellowFlag = yellowFlag;
}
const SET_FILTER_GREEN_FLAG = (state, greenFlag)=>{
  state.filters.greenFlag = greenFlag;
}
const SET_FILTER_SALES_REP = (state, salesRep)=>{
  state.filters.salesRep = salesRep;
}

const SET_FILTER_DELAYED = (state, delayed)=>{
  state.filters.delayed = delayed;
}

const RESET_FILTERS = (state)=>{
  state.filters.active = true;
  state.filters.intent = true;
  state.filters.completed = false;
  state.filters.inactive = false;
  state.filters.redFlag = false;
  state.filters.yellowFlag = false;
  state.filters.greenFlag = false;
  state.filters.salesRep = [];
  state.filters.delayed = true;
  state.filters.customerId = null;
  state.filters.productId = null;
  state.searchTerms = '';
  state.filters.inventories = [];
  state.filters.checkedCustomerClasses = [];
}

const SET_MODE = (state, mode)=>{
  state.mode = mode;
}

const UPDATE_RESERVATIONS = (state, reservations)=>{
  state.reservations.push(...reservations);
}

const SET_FILTER_CUSTOMER_ID = (state, customerId) => {
  state.filters.customerId = customerId;
}
const SET_FILTER_INVENTORIES = (state, inventories) => {
  state.filters.inventories = inventories;
}

const SET_FILTER_PRODUCT_ID = (state, productId) => {
  state.filters.productId = productId;
}

const CHANGE_CHECKED_CUSTOMER_CLASSES_FILTER = (state, checkedCustomerClasses)=>{
  state.filters.checkedCustomerClasses = checkedCustomerClasses;
}


export default {
  SET_LOADING,
  SET_RESERVATIONS,
  SET_CUSTOMER_RESERVATIONS,
  SET_SELECTED_RESERVATION,
  DELETE_SELECTED_RESERVATION,
  INVALIDATE_LIST,
  SET_COUNT,
  SET_PAGES,
  SET_PAGE,
  SET_SEARCH_TERMS,
  SET_ORDERNAME_AND_DIRECTION,
  SET_SORT_ICON,
  UPDATE_SELECTED_RESERVATION,
  SET_ACTIVE_TAB,
  SET_FILTER_ACTIVE,
  SET_FILTER_COMPLETED,
  SET_FILTER_INTENT,
  SET_FILTER_INACTIVE,
  SET_FILTER_RED_FLAG,
  SET_FILTER_YELLOW_FLAG,
  SET_FILTER_GREEN_FLAG,
  SET_FILTER_SALES_REP,
  SET_FILTER_DELAYED,
  RESET_FILTERS,
  SET_MODE,
  UPDATE_RESERVATIONS,
  SET_FILTER_CUSTOMER_ID,
  SET_FILTER_PRODUCT_ID,
  SET_SELECTED_RESERVATION_BY_ID,
  SET_FILTER_INVENTORIES,
  CHANGE_CHECKED_CUSTOMER_CLASSES_FILTER
};
